<template>
	<table class="table">
		<tbody>
			<VideoRow
				:video="video"
				v-for="video in videos"
				v-bind:key="video.id"
			></VideoRow>
		</tbody>
	</table>
</template>

<script>
	import VideoRow from "./VideoRow";

	export default {
		name: "VideoTable",
		components: { VideoRow },
		props: {
			videos: {
				type: Array,
				required: true
			}
		}
	};
</script>
